'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ORDINAL_ALPHA_LOWER_ASC = 'abcdefghijklmnopqrstuvwxyz';
var ORDINAL_ALPHA_LOWER_DEC = 'zyxwvutsrqponmlkjihgfedcba';
var ORDINAL_ALPHA_UPPER_ASC = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
var ORDINAL_ALPHA_UPPER_DEC = 'ZYXWVUTSRQPONMLKJIHGFEDCBA';

var hasOrdinalSignificance = function hasOrdinalSignificance(string) {
    return ORDINAL_ALPHA_LOWER_ASC.indexOf(string) !== -1 || ORDINAL_ALPHA_LOWER_DEC.indexOf(string) !== -1 || ORDINAL_ALPHA_UPPER_ASC.indexOf(string) !== -1 || ORDINAL_ALPHA_UPPER_DEC.indexOf(string) !== -1;
};

exports.default = function (passwordUnderTest) {
    var largestSequence = 0,
        currentSubString = null,
        i = 0,
        j = null;
    for (i; i < passwordUnderTest.length; i++) {
        j = 3;
        for (j; j <= passwordUnderTest.length; j++) {
            currentSubString = passwordUnderTest.substr(i, j);
            if (hasOrdinalSignificance(currentSubString) && currentSubString.length > largestSequence) {
                largestSequence = currentSubString.length;
            }
        }
    }
    return largestSequence / passwordUnderTest.length;
};
//# sourceMappingURL=alpha-ordinal-penalty.js.map